import type { BarcodeValue, ParsedBarcode } from './types'

export const parseBarcode = (code: BarcodeValue): ParsedBarcode => {
    if (!code) {
        return {}
    }

    if (typeof code !== 'string') {
        return {}
    }

    const [first, second] = code.split('-') || []

    if (!first) {
        return {
            code,
        }
    }

    if (!second) {
        return {
            code,
        }
    }

    const numericSecond = +second

    if (Number.isNaN(numericSecond)) {
        return {
            code,
        }
    }

    return {
        code,
        docTypeShortCode: first.toUpperCase(),
        stockNumber: numericSecond,
    }
}

export default parseBarcode
